/**
 * Keys of the project-details tabs (ProjectDetailsTabs.container). A link to a
 * tab is `?tab=<key>` on the project's URL and must use these, never a literal,
 * so a tab reorder can't silently break a link. The values are identities, not
 * positions: display order is the `allItems` array (Data Checks, key "9", is shown
 * between Data Import and Data Reporting; Tables, Dashboards and Provenance come
 * after Data Reporting).
 */
export const PROJECT_TAB_KEYS = {
  GENERAL: "1",
  QUESTIONNAIRE: "2",
  DOCUMENTS: "3",
  DATA_IMPORT: "4",
  DATA_REPORTING: "5",
  DASHBOARDS: "6",
  TABLES: "7",
  PROVENANCE: "8",
  DATA_CHECKS: "9",
} as const

export type ProjectTabKey =
  (typeof PROJECT_TAB_KEYS)[keyof typeof PROJECT_TAB_KEYS]
